module.exports = __webpack_public_path__ + "static/img/park4.ab37e02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/park4.jpg
// module id = Eudk
// module chunks = 1